import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs))
}

export const splitStringUsingRegex = (input: string): string[] => {
  const characters: string[] = []
  const regex = /[\s\S]/g

  let match

  while ((match = regex.exec(input)) !== null) {
    characters.push(match[0])
  }

  return characters
}

export const splitStringIntoLines = (
  input: string,
  width?: number
): string[] => {
  const words = input.split(" ")
  let lines

  if (width && width < 640) {
    lines = [
      words.slice(0, 3).join(" ") + " ", // First 3 words
      words.slice(3, 5).join(" ") + " ", // Next 2 words
      words.slice(5, 7).join(" ") + " ", // Next 2 words
      words.slice(7).join(" "), // Remaining words
    ]
  } else {
    lines = [
      words.slice(0, 4).join(" ") + " ", // First 4 words
      words.slice(4, 7).join(" ") + " ", // Next 3 words
      words.slice(7).join(" "), // Remaining words
    ]
  }

  return lines
}

export const formatDate = (dateString: string) => {
  if (!dateString) return ""

  const date = new Date(dateString)
  const day = String(date.getDate()).padStart(2, "0")
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const year = String(date.getFullYear()).slice(-2)

  return `${day}.${month}.${year}`
}
